import { Action } from '@anm/components/ActionsDropdown';
import { Item } from '@anm/components/ActionsDropdown/ActionItem';
import Tooltip from '@anm/components/Tooltip';
import { getLinkTarget, getUpgradeLinkProps } from '@anm/helpers/upgradeLink';
import { FC } from 'react';

import { ActionItemWrapper, ActionTooltip, ActionTooltipWrapper, ItemWrapper, RelativeWrapper } from './Wrapper';

type PublishUrlProp = { publishUrl?: string };

type StreamVideoTooltipProps = PublishUrlProp & {
  action: Action;
  isUserFree: boolean;
  showBeta?: boolean;
  handler?: () => void;
  isNotStable?: boolean;
};

type StreamActionProps = StreamVideoTooltipProps & {
  canStreamVideo: boolean;
  showBeta?: boolean;
  isNotStable?: boolean;
};

const StreamPublishTooltip: FC<PublishUrlProp> = ({ publishUrl }) => (
  <ActionTooltip>
    This video has not been published yet.{' '}
    <a href={publishUrl} target={getLinkTarget()}>
      Publish it in the editor
    </a>{' '}
    to stream it.
  </ActionTooltip>
);

const StreamUpgradeTooltip: FC = () => (
  <ActionTooltip>
    Please <a {...getUpgradeLinkProps()}>upgrade</a>
    <br />
    To stream this video.
  </ActionTooltip>
);

const StreamVideoActionWithTooltip: FC<StreamVideoTooltipProps> = ({
  action,
  isUserFree,
  showBeta,
  publishUrl,
  handler
}) => (
  <ActionTooltipWrapper>
    <Tooltip
      delayShow={500}
      direction="top-center"
      renderContent={() => (isUserFree ? <StreamUpgradeTooltip /> : <StreamPublishTooltip {...{ publishUrl }} />)}
    >
      <ActionItemWrapper>
        <Item {...action} {...{ handler, showBeta }} disabled={true} />
      </ActionItemWrapper>
    </Tooltip>
  </ActionTooltipWrapper>
);

const StreamVideoAction: FC<StreamActionProps> = ({
  action,
  showBeta = false,
  handler,
  isUserFree,
  canStreamVideo,
  publishUrl
}) => (
  <RelativeWrapper as="div" {...{ ...action, handler }}>
    {canStreamVideo ? (
      <ItemWrapper onClick={handler}>
        <Item {...action} {...{ showBeta }} />
      </ItemWrapper>
    ) : (
      <StreamVideoActionWithTooltip {...{ isUserFree, action, showBeta, publishUrl }} />
    )}
  </RelativeWrapper>
);

export default StreamVideoAction;
